import { useMemo } from 'react'

import { usePoolsIdentity } from '@/data/marketApi/hooks/usePoolsIdentity'
import { buildPoolDetailLink } from '@/features/liquidity/poolProfileFromCurrencies'
import { useAppWeb3 } from '@/hooks'
import { currencyEquals, Currency } from '@/sdk'

export function useSwapPoolDetailLink(
  input: Currency | undefined,
  output: Currency | undefined,
): { href: string | null; canView: boolean } {
  const { chainId } = useAppWeb3()
  const { data: pools } = usePoolsIdentity()

  return useMemo(() => {
    if (!chainId || !input || !output || currencyEquals(input, output)) {
      return { href: null, canView: false }
    }

    return {
      href: buildPoolDetailLink(input, output, chainId, pools),
      canView: true,
    }
  }, [chainId, input, output, pools])
}
